export class ObjectUtils {
    static getCommaSeparatedValuesFromListForKey(list, key) {
        let commaSeparated = "";
        if (!list || list.length <= 0) {
            return commaSeparated;
        }
        list.forEach((item) => {
            const value = item[key];
            if (!value) {
                return;
            }
            if (item === list[list.length - 1]) {
                commaSeparated += `${value}`;
            }
            else {
                commaSeparated += `${value},`;
            }
        });
        return commaSeparated;
    }
    static groupBy = (list, getKey) => {
        return list.reduce((previous, currentItem) => {
            const group = getKey(currentItem);
            if (!previous[group]) {
                previous[group] = [];
            }
            previous[group].push(currentItem);
            return previous;
        }, {});
    };
}
